import { s } from '../lib/sx'
import { PageHero } from '../components/PageHero'
import { Plate } from '../components/Plate'
import { copy } from '../content/copy'
import { leaders } from '../content/leadership'

export function Leadership() {
  return (
    <div>
      <PageHero eyebrow="Leadership" title={copy.leadership.headline} />
      <section style={s('max-width:1320px;margin:0 auto;padding:clamp(48px,7vw,80px) clamp(18px,4vw,32px) 100px;')}>
        <div style={s('display:grid;grid-template-columns:repeat(auto-fit,minmax(min(100%,220px),1fr));gap:28px;')}>
          {leaders.map((l, i) => (
            <div key={i}>
              <Plate box="aspect-ratio:4/5;display:flex;align-items:flex-end;padding:14px;" caption="portrait" captionStyle="padding:5px 7px;font-size:9.5px;" />
              <h3 style={s('font-family:Archivo,sans-serif;font-weight:700;font-size:18px;margin:20px 0 6px;')}>{l.name}</h3>
              <div style={s("font-family:'IBM Plex Mono',monospace;font-size:10.5px;letter-spacing:0.12em;text-transform:uppercase;color:#A8500F;")}>{l.role}</div>
              <div style={s('font-size:12.5px;color:#7E8894;margin-top:8px;')}>{l.cred}</div>
              <p style={s('font-size:14px;line-height:1.6;color:#566070;margin:12px 0 0;')}>{l.bio}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  )
}
